import priceData from "./price-data";


export default {
  priceData,
}
